import VeeValidate from 'vee-validate'
import store from '../store'
import { mapMimeTypeToGeneralType } from '../helpers'

const lowercase = {
  getMessage(field, params, data) {
    return (data && data.message) || 'Something went wrong'
  },
  validate(value) {
    const matches = /^(?=.*[a-z]).+$/.exec(value)
    return new Promise(resolve => {
      resolve({
        valid: matches ? true : false,
        data: { message: 'The password must contain a lowercase letter.' }
      })
    })
  }
}

const uppercase = {
  getMessage(field, params, data) {
    return (data && data.message) || 'Something went wrong'
  },
  validate(value) {
    const matches = /^(?=.*[A-Z]).+$/.exec(value)
    return new Promise(resolve => {
      resolve({
        valid: matches ? true : false,
        data: { message: 'The password must contain an uppercase letter.' }
      })
    })
  }
}

const numberOrSpecial = {
  getMessage(field, params, data) {
    return (data && data.message) || 'Something went wrong'
  },
  validate(value) {
    const matches = /^(?=.*(\d|_|\W)).+$/.exec(value)
    return new Promise(resolve => {
      resolve({
        valid: matches ? true : false,
        data: { message: 'The password must contain a number or a special character.' }
      })
    })
  }
}

const organizationName = {
  getMessage(field, params, data) {
    return (data && data.message) || 'Something went wrong'
  },
  validate (value) {
    const matches = /^[a-zA-Z0-9-_ &]+$/.exec(value)
    return new Promise(resolve => {
      resolve({
        valid: matches ? true : false,
        data: { message: 'The name field may contain alpha-numeric characters as well as dashes, underscores, ampersands, and spaces.' }
      })
    })
  }
}

const sizeValidation = (file, type) => {
  const kilobyte = 'KB'
  const megabyte = 'MB'
  const maxKilobyteSize = 999
  const minSize = Number(store.state.config.data[type].min_size)
  const displayMinSize = minSize > maxKilobyteSize ? minSize / 1000 : minSize
  const minSizeUnit = minSize > maxKilobyteSize ? megabyte : kilobyte
  const maxSize = Number(store.state.config.data[type].max_size)
  const displayMaxSize = maxSize > maxKilobyteSize ? maxSize / 1000 : maxSize
  const maxSizeUnit = maxSize > maxKilobyteSize ? megabyte : kilobyte

  const fileSize = file.size
  const displayFileSize = fileSize > maxKilobyteSize ? Math.round(fileSize / 1000000) : fileSize
  const fileSizeUnit = fileSize > maxKilobyteSize ? megabyte : kilobyte
  const message = `The file size is approximately ${displayFileSize} ${fileSizeUnit}. The ${type} must be between ${displayMinSize} ${minSizeUnit} and ${displayMaxSize} ${maxSizeUnit}`

  return new Promise(resolve => {
    resolve({
      valid: file.size >= minSize * 1000 && Math.round(file.size / 1000000) <= maxSize / 1000,
      data: { message }
    })
  })
}

const dimensionValidation = (file, type) => {
  const URL = window.URL || window.webkitURL
  const minWidth = store.state.config.data[type].min_width
  const minHeight = store.state.config.data[type].min_height

  const message = `The ${type} must be at least ${minWidth} pixels by ${minHeight} pixels.`

  return new Promise(resolve => {
    const image = new Image()
    image.onerror = () => resolve({ valid: false, data: {message} })
    image.onload = () => resolve({
      valid: image.width >= Number(minWidth) && image.height >= Number(minHeight),
      data: { message }
    })

    if (file) {
      image.src = URL.createObjectURL(file)
    } else {
      resolve({
        valid: false,
        data: { message }
      })
    }
  })
}

const validatePDF = {
  getMessage(field, params, data) {
    return (data && data.message) || 'Something went wrong'
  },
  validate(files) {
    return sizeValidation(files[0], 'pdf')
  }
}

const validateVideo = {
  getMessage(field, params, data) {
    return (data && data.message) || 'Something went wrong'
  },
  validate(files) {
    return sizeValidation(files[0], 'video')
  }
}

const validateImage = {
  getMessage(field, params, data) {
    return (data && data.message) || 'Something went wrong'
  },
  validate(files) {
    return dimensionValidation(files[0], 'image')
  }
}

const validateAudio = {
  getMessage(field, params, data) {
    return (data && data.message) || 'Something went wrong'
  },
  validate(files) {
    return sizeValidation(files[0], 'audio')
  }
}

const validateThumbnail = {
  getMessage(field, params, data) {
    return (data && data.message) || 'Something went wrong'
  },
  validate(files) {
    return dimensionValidation(files[0], 'thumbnail')
  }
}

const validateAnyFile = {
  getMessage(field, params, data) {
    return (data && data.message) || 'Something went wrong'
  },

  validate(files) {
    const file = files[0] // only ever validate a single file

    if (file && file.type) {
      const type = mapMimeTypeToGeneralType(file.type)

      if (type === 'thumbnail') {
        return dimensionValidation(file, type)
      } else if (type === 'image') {
        return dimensionValidation(file, type)
      } else {
        return sizeValidation(file, type)
      }
    }

    return new Promise(resolve => {
      resolve({ valid: false })
    })

  }
}

VeeValidate.Validator.extend('uppercase', uppercase)
VeeValidate.Validator.extend('lowercase', lowercase)
VeeValidate.Validator.extend('numberOrSpecial', numberOrSpecial)
VeeValidate.Validator.extend('validatePDF', validatePDF)
VeeValidate.Validator.extend('validateVideo', validateVideo)
VeeValidate.Validator.extend('validateImage', validateImage)
VeeValidate.Validator.extend('validateAudio', validateAudio)
VeeValidate.Validator.extend('validateThumbnail', validateThumbnail)
VeeValidate.Validator.extend('validateAnyFile', validateAnyFile)
VeeValidate.Validator.extend('organizationName', organizationName)

const validationConfig = {
  delay: 0,
  fieldsBagName: 'validationFields'
}

export { VeeValidate as validation, validationConfig }



// WEBPACK FOOTER //
// ./src/validation/index.js